/*
 * @Description 组件 设备数量统计
 * @Author 
 * @Date 
 */
/* HTML */
<template>
	<!-- index-sub-item start -->
	<div class="index-sub-item sub-item-statistic" v-resize="elFormResize">
		<div class="sub-items-box-top"></div>
		<!-- sub-statistic-box -->
		<div class="sub-items-box-center sub-statistic-box">
			<div class="index-sub-title">设备数量统计</div>
			<!-- sub-statistic-content start -->
			<div class="sub-statistic-content">
				
				<!-- statistic-item-box start -->
				<div class="statistic-item-box">
					<!-- 暂无数据 start -->
					<div v-if="$checkEmpty(dataList)" class="flex-center" style="color: #fff;font-size: 30px;height: 100%;width: 100%;">暂无数据</div>
					<!-- chart -->
					<div v-show="!$checkEmpty(dataList)" id="chart_devices" class="lb-item-wrap"></div>
					<!-- 工时统计 -->
				</div>
				<!-- statistic-item-box end -->
			</div>
			<!-- sub-statistic-content end -->
		</div>
		<!-- sub-statistic-box -->
		<div class="sub-items-box-bottom"></div>
	</div>
	<!-- index-sub-item end -->
</template>

/* JS */
<script>
	// API oam
	import ApiOam from '@/request/api-oam';
	// API 视频接口
	import ApiVideo from '@/request/api-video';
	
	export default {
		/**
		 * @Des 组件名
		 * @Auth
		 * @Date 
		 */
        name: "IndDeviceStatistic",
        
        /**
		 * @Des 组件注册
		 * @Auth
		 * @Date 
		 */
        components: {
        	
        },// components
        
        /**
		 * @Des 属性值
		 * @Auth
		 * @Date 
		 */
        props: {
        	
        },// props
        
        /**
		 * @Des 数据定义
		 * @Auth
		 * @Date 
		 */
		data() {
			return {
				// 数据列表
				dataList: [
					{num: 0, label: '定位基站', type: 'bs'},
					{num: 0, label: '定位标签', type: 'tag'},
					{num: 0, label: '监控视频', type: 'video'},
				],
				
				// 时间戳
				queryTime: null,
				// flag 完成交互
				queryFlag_bs: true,
				queryFlag_tag: true,
				queryFlag_video: true,
				chartInit_flag: true,
				
				// 定时器
				timer_checkDataInt: null,// 检索数据
				timer_initCharts: null,// 初始化 图表
			}
		},// data
		
		/**
		 * @Des 初始化
		 * @Auth
		 * @Date 
		 */
		created() {
			
		},// created
		
		/**
		 * @Des 加载完成
		 * @Auth
		 * @Date 
		 */
		mounted() {
			// 开启订阅消息
			this.startSubscribes();
			
			// 数据查询
			this.searchData();
		},// mounted
		
		/**
		 * @Des 销毁之前
		 * @Auth
		 * @Date 
		 */
		beforeDestroy() {
			// 取消订阅消息
			this.endSubscribes();
			// 关闭 timer
        	this.endTimers();
		},// beforeDestroy
		
		/**
		 * @Des 销毁
		 * @Auth
		 * @Date 
		 */
		destroyed() {
			
		},// destroyed
		
		/**
		 * @Des 方法定义
		 * @Auth
		 * @Date 
		 */
		methods: {
			/**
        	 * @Des 关闭 timer
        	 * @Auth
        	 * @Date
        	 */
        	endTimers() {
				// 清除计时器
				if (!this.$checkEmpty(this.timer_checkDataInt)) {
					clearInterval(this.timer_checkDataInt);
					this.timer_checkDataInt = null;
				}
				// 清除计时器
				if (!this.$checkEmpty(this.timer_initCharts)) {
					clearTimeout(this.timer_initCharts);
					this.timer_initCharts = null;
				}
        	},
			/**
			 * @Des dom 尺寸更改
			 * @Auth
			 * @Date 
			 */
			elFormResize(data) {
				// 检索数据初始化
				this.checkDataInt(true);
			},// elFormResize
			
			/**
			 * @Des 检索数据初始化
			 * @Auth
			 * @Date 
			 */
			checkDataInt(disposeFlag) {
				// 清除定时器
				if (!this.$checkEmpty(this.timer_checkDataInt)) {
					// 清除定时器
					clearInterval(this.timer_checkDataInt);
				}
				
				// queryFlag_bs queryFlag_tag queryFlag_video
				if (this.queryFlag_bs && this.queryFlag_tag && this.queryFlag_video) {
					// dispose
					this.$nextTick(() => {
						// 初始化 charts
						this.initCharts();
					});// $nextTick
				} else {
					// 定时器
					this.timer_checkDataInt = setInterval(() => {
						if (this.queryFlag_bs && this.queryFlag_tag && this.queryFlag_video) {
							// 清除定时器
							clearInterval(this.timer_checkDataInt);
							this.timer_checkDataInt = null;
							
							// dispose
							this.$nextTick(() => {
								// 初始化 charts
								this.initCharts();
							});// $nextTick
						}
					}, 400);
				}
			},
			
			//========================== 订阅消息 start ==========================
			/**
			 * @Des 开启订阅消息
			 * @Auth
			 * @Date
			 */
			startSubscribes() {
				// 订阅消息 标签变化
				this.sub_tagChange = this.$pubsub.subscribe('TagChange', (name, data) => {
					// 数据查询
					this.searchData();
				});
				// 订阅消息 视频配置
				this.sub_videoChange = this.$pubsub.subscribe('VideoChange', (name, data) => {
					// 数据查询
					this.searchData();
				});
			},
			/**
			 * @Des 取消订阅消息
			 * @Auth
			 * @Date
			 */
			endSubscribes() {
				//取消订阅 标签变化
				this.$pubsub.unsubscribe(this.sub_tagChange);
				//取消订阅 视频配置
				this.$pubsub.unsubscribe(this.sub_videoChange);
			},
			
			//========================== 订阅消息 end ==========================
			
			/**
			 * @Des 点击条目btn
			 * @Auth
			 * @Date
			 */
			handleItemBtn(row) {
				// 空值 中止
				if (this.$checkEmpty(row) || !(row.num > 0)) {
					return false;
				}
				// 点击 更多 或 数量 > 0 的设备条目
				
				// 路由 跳转
				this.$router.replace({path: ('/manager/device/' + row.type)}, ()=>{}, ()=>{});
				
				return false;
				// 参数
				let filter = {};
				if (!this.$checkEmpty(row) && !this.$checkEmpty(row.type)) {
					filter.activeName = row.type;
				}

				// 点击条目
				this.handleDetailBtn('TyDevice', '各类设备', filter);
			},
			
			/**
			 * @Des 点击条目
			 * @Auth
			 * @Date
			 */
			handleDetailBtn(detailSubRef, detailSubName, detailFilters) {
				// 发布消息 详情页
				this.$pubsub.publish('handleDetail', {showDetailFlag: true, detailSubRef: detailSubRef, detailSubName: detailSubName, detailFilters: detailFilters});
			},
			
			/**
			 * @Des title 拼接
			 * @Auth
			 * @Date
			 */
			spliceTitle(row) {
				let title = row.label + '：' +row.num + ' 台';
				if (row.num > 0) {
					title += '\n（点击数字查看详情）';
				}
				return title;
			},
			
			//========================== 数据查询  start ==========================
			/**
			 * @Des 数据查询
			 * @Auth 
			 * @Date 
			 */
			searchData(){
				// 正在查询 未完毕 中止
				if (!(this.queryFlag_bs && this.queryFlag_tag && this.queryFlag_video && this.chartInit_flag)) {
					return false;
				}
				
				// 时间戳
				let t = new Date().getTime();
				this.queryTime = t;
				// flag 完成交互
				this.queryFlag_bs = false;
				this.queryFlag_tag = false;
				this.queryFlag_video = false;
				this.chartInit_flag = false;
				
				// 数据查询 基站
				this.searchBsData(t);
				// 数据查询 标签
				this.searchTagData(t);
				// 数据查询 视频
				this.searchVideoData(t);
				
				// 检索数据初始化
				this.checkDataInt();
				
			},// searchData
			
			/**
			 * @Des 数据查询 基站
			 * @Auth 
			 * @Date 
			 */
			searchBsData(t) {
				this.$request.postJsonRequest(ApiOam.Search_Uwb_Bs_Uri,{
					projectId: this.$store.state.currentProjectId,
					startNum: 0,
					limit: 1
				}).then(result => {
					// 比对时间戳
					if (t == this.queryTime) {
						// 数据列表 标签
						this.dataList[0].num = result.total > 0 ? result.total : 0;
						// flag 完成交互
						this.queryFlag_bs = true;
					}
				}).catch(error => {
					// 比对时间戳
					if (t == this.queryTime) {
						// 数据列表 标签
						this.dataList[0].num = 0;
						// flag 完成交互
						this.queryFlag_bs = true;
					}
					console.error('查询基站数据异常', ApiOam.Search_Uwb_Bs_Uri, error);
				})
			},// searchBsData
			/**
			 * @Des 数据查询 UWB标签
			 * @Auth 
			 * @Date 
			 */
			searchTagData(t) {
				this.$request.postJsonRequest(ApiOam.Search_Uwb_Tag_Uri,{
					projectId: this.$store.state.currentProjectId,
					startNum: 0,
					limit: 1
				}).then(result => {
					// 比对时间戳
					if (t == this.queryTime) {
						// 数据列表 标签
						this.dataList[1].num = result.total > 0 ? result.total : 0;
						// flag 完成交互
						this.queryFlag_tag = true;
					}
				}).catch(error => {
					// 比对时间戳
					if (t == this.queryTime) {
						// 数据列表 标签
						this.dataList[1].num = 0;
						// flag 完成交互
						this.queryFlag_tag = true;
					}
					console.error('查询标签数据异常', ApiOam.Search_Uwb_Tag_Uri, error);
				})
			},// searchTagData
			
			/**
			 * @Des 查询数据 视频
			 * @Auth
			 * @Date
			 */
			searchVideoData(t) {
				this.$request.postJsonRequest(ApiVideo.searchVideoApi, {
					projectId: this.$store.state.currentProjectId,
					isOpen: 1,
					offset: 0,
					limit: 1,
					total: 0
				}).then(result => {
					// 比对时间戳
					if (t == this.queryTime) {
						// 数据列表 标签
						this.dataList[2].num = result.total > 0 ? result.total : 0;
						// flag 完成交互
						this.queryFlag_video = true;
					}
				}).catch(error => {
					// 比对时间戳
					if (t == this.queryTime) {
						// 数据列表 标签
						this.dataList[2].num = 0;
						// flag 完成交互
						this.queryFlag_video = true;
					}
					console.error('查询摄像头异常', ApiVideo.searchVideoApi, error);
				})
            },// searchVideoData
			//========================== 数据查询  end ==========================
			
			/**
			 * @Des 初始化 charts
			 * @Auth
			 * @Date 
			 */
			initCharts() {
				// 清除计时器
				if (!this.$checkEmpty(this.timer_initCharts)) {
					clearTimeout(this.timer_initCharts);
					this.timer_initCharts = null;
				}
				
				this.chartInit_flag = false;
				// dispose
				if (this.myChart) this.myChart.dispose();
				// myChart 设备的数量
				this.myChart = this.$echarts.init(document.getElementById('chart_devices'));
				// 初始化 chart 设备的数量
				this.initChart();
				this.chartInit_flag = true;
				
				this.timer_initCharts = setTimeout(() => {
					// 初始化 charts
					this.initCharts();
				}, 10*1000);
			},
			
			/**
			 * @Des 初始化 chart 设备数量 饼图
			 * @Auth
			 * @Date 2021/10/8
			 */
			initChart_pie() {
				
				// 数据重组
				let dataList = Object.assign([], this.dataList);
				
				// 遍历 提取数据
				dataList.forEach((row, index) => {
					row.value = !this.$checkEmpty(row.val) ? row.val : 0;
				});
				
				let THIS = this;
				this.option = {
					darkMode: false,
					textStyle: {
						/*color: '#B9B8CE'*/
						color: '#fff'
					},
					title: {
						text: '',
						subtext: '',
						left: 'center',
						textStyle: {
							color: '#fff',
							fontSize: 18,
							fontWeight: 'bold'
						},
						subtextStyle: {
							color: '#fff',
							fontSize: 12
						}
					},
					tooltip: {
						trigger: 'item',
						textStyle: {
							align: 'justify'
						}
					},
					legend: {
						//orient: 'vertical',
						left: 'left',
						textStyle: {
							color: '#fff',
							lineHeight: 0,
							height: 0,
							rich:{
		                        a:{
		                            fontSize:14,
		                            align:'left',
		                            padding:[0,0,0,0],
		                            verticalAlign: 'middle'
		                        },
		                        b:{
		                            fontSize:18,
		                        	lineHeight: 40,
		                        	
		                            align:'center',
		                            padding:[10,0,0,0],
		                            fontWeight: 'bold'
		                        }
							}
						},
						icon:'circle',
						formatter: function (name) {
							let data = THIS.option.series[0].data
							// console.log(data, 'data')
							let total = 0
							let tarValue
							for (let i = 0; i < data.length; i++) {
								total += data[i].value
								if (data[i].name == name) {
									tarValue = data[i].value
								}
							};
							let v = tarValue + '人';
							//计算出百分比
							let p = Math.round((tarValue / total) * 100) + '%';
							
							return  '{a|'+ name +' }\n{b|'+ v +'}';
							//return `${name}  \n ${'<b>'+v+'</b>'}`;
							//name是名称，v是数值
						},
					},
					color: ['#ffcc43', '#ff4343', '#4375ff', '#4185f0', '#feb10d', '#08d5fb', '#05c091', '#58d9f9', '#4992ff', '#7cffb2', '#ff8a45', '#8d48e3', '#fddd60', '#dd79ff', '#ff6e76', ],
					series: [
						{
							name: '人员数量',
							type: 'pie',
							//radius: '60%',
							radius: ['50%', '60%'],
							data: dataList,
							emphasis: {
								itemStyle: {
									shadowBlur: 10,
									shadowOffsetX: 0,
									shadowColor: 'rgba(0, 0, 0, 0.8)'
								}
							},
							label: {
								show: false
							},
							labelLine: {
								show: false
							}
						}
					]
				};
				// set option
				this.myChart.setOption(this.option);
			},// initChart
			
			/**
			 * @Des 初始化 chart 设备的数量
			 * @Auth
			 * @Date 
			 */
			initChart() {
				// 数据重组
				let dataList = Object.assign([], this.dataList);
				
				let nameList = [];
				let numList = [];
				// 遍历 提取数据
				dataList.forEach((row, index) => {
					nameList.push(row.label);
					numList.push(row.num);
				});
				
				this.option = {
					darkMode: true,
					textStyle: {
						color: '#fff'
					},
					title: {
						text: '',
						subtext: '',
						textStyle: {
							color: '#B9B8CE',
							fontSize: 18,
							fontWeight: 'bold'
						},
						subtextStyle: {
							color: '#B9B8CE',
							fontSize: 12
						},
						left: 'center',
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						},
						textStyle: {
							align: 'justify'
						}
					},
					legend: {
						show: false,
						left: 'right',
						textStyle: {
							color: '#B9B8CE'
						}
					},
					grid: {
						top: '10%',
						left: '0%',
						right: '4%',
						bottom: '3%',
						containLabel: true
					},
					yAxis: {
						show: false,
						type: 'value',
						boundaryGap: [0, 0.01],
						minInterval: 1,
						axisLine: {
							show: true
						},
						axisTick: {
							show: true
						}
					},
					xAxis: {
						type: 'category',
						axisLabel: {
							interval:0, //强制显示文字
						},
						data: nameList
					},
					series: [
						{
							name: '数量',
							type: 'bar',
							label: {
								show: true,
								formatter: '{c}',
								color: '#fff',
								fontSize: 16,
								position: 'top', //在上方显示
							},
							itemStyle: {
								color: function (param) {
									let colorList = [
										'#ffcc43', '#008001', '#808080', '#51dd0f', '#6fdb3b', '#60c230',
										'#98e274', '#8acc6a', '#74ac59', '#55e50f', '#4ac90c', '#42b10c',
									];
									return colorList[param.dataIndex] || 'red';
								}
							},
							data: numList
						}
					]
				};
				
				// set option
				this.myChart.setOption(this.option);
			},// initChart
			
		},// methods
		
		/**
		 * @Des 监听
		 * @Auth
		 * @Date 
		 */
		watch: {
			
		},// watch
		
		/**
		 * @Des 实时计算
		 * @Auth
		 * @Date 
		 */
		computed: {
			
		},// computed
		
    }// export default
</script>

/* CSS */
<style lang="scss" scoped>
	
</style>



// WEBPACK FOOTER //
// src/components_index/IndexItems/IndDeviceStatistic.vue